<template>
    <div class="form-group flex-fill">
        <label>{{title}}</label>
        <input ref="companyAddress" @focus="initAutoComplete" v-model="inputVal" type="text" class="form-control" name="address" :placeholder="placeholder">
        <span class="error" v-if="errors">{{ errors[0] }}</span>
    </div>
</template>

<script>
export default {
    name: "GooglePlaceAutoComplete",
    props: ['title', 'placeholder', 'value', 'rules', 'errors'],
    computed: {
        inputVal: {
            get() {
                
                return this.value;
            },
            set(val) {
               // this.$emit('input', val);
            }
        }
    },
    mounted() {
        window.checkAndAttachMapScript(this.initLocationSearch);
    },
    methods: {
        initAutoComplete(){
            //window.checkAndAttachMapScript(this.initLocationSearch);
        },
        initLocationSearch() {
            let self = this;
            const southwest = { lat: 22.3436288, lng: 88.1165879 };
            const northeast = { lat: 23.0083628, lng: 88.5428696 };
            let defaultBounds = new window.google.maps.LatLngBounds(southwest, northeast);

            const options = {
                //bounds: defaultBounds,
                //types: ['geocode'],
                strictBounds: false,
                //componentRestrictions: { country: "in" },
                fields: ["formatted_address", "geometry", "name", "address_components"]
            };

            let companyAddress = new window.google.maps.places.Autocomplete(self.$refs.companyAddress, options);
            companyAddress.addListener("place_changed", function() {
                let place = companyAddress.getPlace();
                console.log('place', place);
                if (place && place.geometry && place.geometry.location) {
                    // let lat = place.geometry.location.lat();
                    // let lng = place.geometry.location.lng();
                    // let pinCode = place.address_components.find((x) => x.types.includes('postal_code'));
                    // let address = place.formatted_address;
                    // if(place.name != '') {
                    //     self.address1 = place.name+' , '+place.formatted_address;
                    // }
                    // else{
                    //     self.address1 = place.formatted_address;
                    // }
                    
                        self.$emit('selectedEvent', place);
                     // Reset the input field after selection
                        //self.inputVal = place.name;
                        //self.$emit('input', place.name);  // Emit the cleared value for v-model
                } else {
                    this.$bvToast.toast('There is an error. Please try again', {
                        title: 'Error',
                        autoHideDelay: 2000,
                        appendToast: true,
                        variant: 'error',
                        solid: true,
                        toaster: 'b-toaster-bottom-center',
                    });
                }
            });
        },
    }

}
</script>

<style scoped>

</style>
